import TomSelect from 'tom-select';

export function initHubspotCompanySelect() {
  if(!$('#hubspot-company-select').length || $('#hubspot-company-select.tomselected').length > 0) return;

  new TomSelect('#hubspot-company-select', {
    placeholder: 'Search for a Hubspot company',
    allowEmptyOption: true,
    valueField: 'id',
    labelField: 'text',
    searchField: ['text'],
    loadThrottle: 500,
    maxOptions: 1000,
    load: function(query, callback) {
      if (!query.length || query.length < 2) return callback();

      fetch(`/user_companies/search_hubspot_companies?q=${encodeURIComponent(query)}`)
        .then(response => response.json())
        .then(data => {
          const results = data.map(company => ({
            id: company.id,
            text: company.name
          }));
          callback(results);
        }).catch(() => {
          callback();
        });
    }
  });
}

export function initApiLogoSelect() {
  if(!$('#hubspot-api-logo-select').length || $('#hubspot-api-logo-select.tomselected').length > 0) return;

  const ts = new TomSelect('#hubspot-api-logo-select', {
    placeholder: 'Search for a logo',
    allowEmptyOption: true,
    valueField: 'id',
    labelField: 'text',
    searchField: ['text'],
    loadThrottle: 1000,
    maxOptions: 10,
    render: {
      item: function(data, escape) {
        return `<div class="flex items-center">
          <img src="${data.logo_url}" width="24" height="24" class="mr-2" />
          <span>${escape(data.text)}</span>
        </div>`;
      },
      option: function(data, escape) {
        return `<div class="flex items-center">
          <img src="${data.logo_url}" width="24" height="24" class="mr-2" />
          <span>${escape(data.text)}</span>
        </div>`;
      }
    },
    load: function(query, callback) {
      if (!query.length || query.length < 2) return callback();

      fetch(`/user_companies/search_api_logo?q=${encodeURIComponent(query)}`)
        .then(response => response.json())
        .then(data => {
          const results = data.map(logo => ({
            id: logo.id,
            text: logo.name,
            logo_url: logo.logo_url
          }));
          callback(results);
        }).catch(() => {
          callback();
        });
    }
  });

  // Preselect previously saved value (if any)
  const el = document.getElementById('hubspot-api-logo-select') as HTMLSelectElement | null;
  if (el) {
    const initialId = el.dataset.initialId || '';
    const initialText = el.dataset.initialText || initialId;
    const initialLogoUrl = el.dataset.initialLogoUrl || initialId;
    if (initialId) {
      // Ensure the option exists with the extra fields TomSelect uses for rendering
      const idValue = `${initialText},${initialLogoUrl}`;
      ts.addOption({ id: idValue, text: initialText, logo_url: initialLogoUrl } as any);
      ts.setValue(idValue, true);
    }
  }
}

export function initCustomersTable() {
  document.querySelectorAll('.customers-table .company-name').forEach((nameElement) => {
    const expandIcon = nameElement.nextElementSibling as HTMLElement;
    if (!expandIcon) {
      return;
    }

    if (nameElement.scrollWidth > nameElement.clientWidth) {
      expandIcon.style.display = 'inline-block';
    } else {
      expandIcon.style.display = 'none';
    }

    expandIcon.addEventListener('click', (event) => {
      event.stopPropagation();
      const target = event.currentTarget as HTMLElement;
      const content = target.getAttribute('data-content');
      const title = target.getAttribute('data-title');
      const modal = $('#fullCompanyNameModal');
      const modalTitle = modal.find('[data-modal-target="title"]');
      const modalContent = modal.find('[data-modal-target="content"]');
      modalTitle.text(title);
      modalContent.text(content);
      modal.modal('show');
    });
  });
}